import * as React from 'react';

import { createIcon } from '../Icon';
export const CloudLightningIcon = createIcon(
  <React.Fragment>
    <path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9" />
    <polyline points="13 11 9 17 15 17 11 23" />
  </React.Fragment>,
  'CloudLightningIcon'
);
